import { z } from 'zod';

/**
 * Phase 4: Reviewer groups. Backed by `org_review_groups` +
 * `org_review_group_members` (migration 050). A group is a named
 * collection of users (e.g. "QA Leads") referenced by codeowners
 * rules. Resolving a group expands to its members at review-creation
 * time.
 */

export const OrgReviewGroupSchema = z.object({
  id: z.string().uuid(),
  orgId: z.string().uuid(),
  name: z.string(),
  description: z.string().nullable(),
  memberCount: z.number().int(),
});
export type OrgReviewGroup = z.infer<typeof OrgReviewGroupSchema>;

export const OrgReviewGroupMemberSchema = z.object({
  groupId: z.string().uuid(),
  userId: z.string().uuid(),
  userName: z.string(),
  email: z.string(),
});
export type OrgReviewGroupMember = z.infer<typeof OrgReviewGroupMemberSchema>;

export const OrgReviewGroupDetailSchema = OrgReviewGroupSchema.extend({
  members: z.array(OrgReviewGroupMemberSchema),
});
export type OrgReviewGroupDetail = z.infer<typeof OrgReviewGroupDetailSchema>;

export const CreateOrgReviewGroupBodySchema = z.object({
  name: z.string().min(1).max(80),
  description: z.string().max(400).optional(),
  memberIds: z.array(z.string().uuid()).max(200).default([]),
});
export type CreateOrgReviewGroupBody = z.infer<typeof CreateOrgReviewGroupBodySchema>;

export const UpdateOrgReviewGroupBodySchema = CreateOrgReviewGroupBodySchema.partial();
export type UpdateOrgReviewGroupBody = z.infer<typeof UpdateOrgReviewGroupBodySchema>;

export const ListOrgReviewGroupsResponseSchema = z.object({
  groups: z.array(OrgReviewGroupSchema),
});
export type ListOrgReviewGroupsResponse = z.infer<typeof ListOrgReviewGroupsResponseSchema>;
